export default __webpack_public_path__ + "static/eventDriven-bb494c74ef29183448a7bd4c6fd53dc2.svg";